// extracted by mini-css-extract-plugin
export default {"important_note":"importantNote_important_note__19Lxj"};